import { JOURNEY_PARAMS } from './constants';
import { IJOURNEY_PARAMS } from './validation';

export const updateJourneyParams = (actionData: IJOURNEY_PARAMS['actionData']): IJOURNEY_PARAMS => {
  return {
    type: JOURNEY_PARAMS,
    actionData,
  };
}
